import type { ProductPageContent } from '../../types/product'
import { salesPos } from './salesPos'
import { inventory } from './inventory'
import { purchases } from './purchases'
import { expenses } from './expenses'
import { customers } from './customers'
import { reports } from './reports'
import { businessFinance } from './businessFinance'

export const productPages: Record<string, ProductPageContent> = {
  [salesPos.slug]: salesPos,
  [inventory.slug]: inventory,
  [purchases.slug]: purchases,
  [expenses.slug]: expenses,
  [customers.slug]: customers,
  [reports.slug]: reports,
  [businessFinance.slug]: businessFinance,
}
